import React from 'react';

type Props = {
  className?: string;
  width?: string;
  height?: string;
};

const Offered: React.FC<Props> = ({ className, width = '24', height = '24' }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" className={className}>
    <path d="M8.25 3a.75.75 0 100 1.5h10c1.24 0 2.25 1 2.25 2.25V17a.75.75 0 001.5 0V6.75A3.75 3.75 0 0018.25 3h-10zM7.25 16.25a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5zM12.25 15a1.25 1.25 0 11-2.5 0 1.25 1.25 0 012.5 0zM16 15a1.25 1.25 0 11-2.5 0 1.25 1.25 0 012.5 0z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 8.13c0-1.18.97-2.16 2.15-2.16L11 6l5.85.02c1.18 0 2.16.98 2.16 2.16v9.68c0 1.18-.97 2.15-2.15 2.15h-8.8L2.54 21.4a.75.75 0 01-.9-.97L3 16.32V8.13zm1.5 0v8.3c0 .09-.01.17-.04.25L3.5 19.6l4.3-1.07a.75.75 0 01.19-.03h8.88c.35 0 .66-.3.66-.65v-4.69l-.01-4.99c0-.35-.3-.66-.66-.66-.38 0-3.11 0-5.84-.02H11l-5.85-.02c-.35 0-.65.3-.65.66z"
    />
  </svg>
);

export default Offered;
